export const ITEMS_PER_ROW = {
  mobile: 3,
  tablet: 4,
  desktop: 4,
};

export const NONE_POSITION = -2;

export const MISS_POSITION = -1;

export const QUICK_MISS_TILES_COUNT = 3;

export const ANIMATION_TILES_COUNT = 13;

export const ANIMATION_TILE_DURATION = 150;
